var _rect, _g, _circle, _g2, _circle2, _g3, _g4, _g5, _polygon, _path, _ellipse, _path2, _path3, _g6, _g7, _text, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#D4E7B1",
    width: 178.6,
    height: 260.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E806F",
    d: "M57.5,230.7c0,0.2-0.4,0.4-0.9,0.4H31.5c-0.5,0-0.9-0.2-0.9-0.4s0.4-0.4,0.9-0.4h25.2 C57.1,230.3,57.5,230.5,57.5,230.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BA3033",
    d: "M32,210.1L32,210.1c-3.5-1.3-4.4,4.9-4.5,5.3s-0.1,0.6-0.1,0.6l0.6-0.2l-0.1,0.6l0.6-0.2l-0.1,0.6l0.6-0.2 l-0.1,0.6l0.5-0.2l-0.1,0.5l0.6-0.2l-0.1,0.6l0.6-0.2l0.3,0.6c0,0,0.6-3.8,0.8-4.4c0.8-2.1,1.3-1.9,1.7-2 C33.3,211.2,32.8,210.4,32,210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2B5A5",
    d: "M66.3,206.5L66.3,206.5l-1.8-1.6l-3.1-2.8l8-10.4l-9.4,9.2l-0.8-0.7l-1.7-1.5c-0.5,0.5-0.8,1.2-0.8,1.9 c0,0,0,0.1,0,0.1c0,0.7,0.3,1.2,0.7,1.6l0,0l-4.2,4.1l0,0c-1.6,1.6-3.5,1.7-3.5,1.7l4.9,6.3c0.3,0.5,0.7,1.2,0.7,0.3 c0-1.2,0.4-1.9,0.6-2.1l1.8-2.5c1.1-1.1,2.8-1.2,4-0.3l0.3,0.3l0.6,0.5l0,0c1.1,0.9,2.8,0.8,3.8-0.3 C67.4,209.2,67.3,207.5,66.3,206.5L66.3,206.5z M60.3,205.2c-0.3,0-0.5-0.2-0.5-0.4c0-0.3,0.2-0.5,0.4-0.5c0.3,0,0.5,0.2,0.5,0.4 C60.7,205,60.5,205.2,60.3,205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA3033",
    d: "M61.3,202.1l8-10.4l-9.4,9.2L61.3,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2B5A5",
    d: "M55.3,213.3c-0.2-2.9-2.7-5.2-5.6-5.2H38.2c-3,0-5.4,2.3-5.7,5.2v17.4h1.6v-11.4c0-0.8,0.7-0.8,0.7-0.8h1.1 c0,0,0.7,0,0.7,0.8c0,0,0,0,0,0v11.4H38v-11.5l0,0c0,0,0-0.8,0.6-0.6c1.1,0.5,3.1,0.8,5.3,0.8c2.1,0,4-0.3,5.2-0.7c0,0,0.1,0,0.1,0 c0.6-0.2,0.6,0.6,0.6,0.6l0,0v11.5h1.6c0,0,0-11.4,0-11.4c0-0.8,0.7-0.8,0.7-0.8h1.1c0,0,0.7,0,0.7,0.8v11.4h1.6L55.3,213.3 L55.3,213.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA3033",
    points: "34.1,229.8 32.5,229.8 32.5,230.7 34.5,230.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA3033",
    points: "38,229.8 36.5,229.8 36.5,230.7 38.5,230.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA3033",
    points: "51.3,229.8 49.8,229.8 49.8,230.7 51.8,230.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BA3033",
    points: "55.3,229.8 53.8,229.8 53.8,230.7 55.7,230.7  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 60,
    cy: 204.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M60.4,204.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0.4-0.8,0.8 c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8c0-0.1,0-0.1,0-0.2C60.7,204.8,60.6,204.9,60.4,204.9z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 23.8,
    cy: 39.2,
    r: 2.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 11.4203 28.6079)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 16
  }, "100"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 143.4,
    cy: 210.3,
    r: 2.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 155.8207 220.8426)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 16
  }, "100"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E806F",
    d: "M138.4,214.9c0,0.3-0.6,0.5-1.3,0.5H78.4c-0.7,0-1.3-0.2-1.3-0.5s0.6-0.5,1.3-0.5h58.8 C137.9,214.4,138.4,214.6,138.4,214.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E806F",
    d: "M56.6,123.8c-4,0-8.1-0.7-12-2.3l4.9-2.8l-2-4.4c11.4,4.5,24.3,0.1,30.7-10.4c6.4-10.5,4.2-24-5-32l5.1-5.9 c12.1,10.5,14.9,28.1,6.6,41.9C78.6,118,67.8,123.8,56.6,123.8z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E806F",
    points: "95.1,214.9 86.9,214.9 87.7,211.2 91.5,210.3 96.9,163.5 119.4,173.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7AA28D",
    d: "M113,94.3C94.6,75.6,61.1,30.6,61.1,30.6L37.9,42.5L29.1,47l-0.5,0.3l0,0c-5.2,3-7.3,9.5-4.9,15l21.7-10.5 c1.7-0.8,3.7-0.1,4.6,1.6c0.8,1.7,0.1,3.7-1.6,4.6l-20,9.6c3.2,1.9,7.3,2.3,10.9,0.6l0,0l3.2-1.6l1.6-0.8c6-2.6,14.7-0.6,16.3,5.3 c1.6,6,5.1,41.2,5.1,41.2C65.8,113.2,121.5,103,113,94.3z M57.4,47c-0.3,1-1.5,1.6-2.5,1.2c-1-0.3-1.6-1.4-1.3-2.5 c0.3-1,1.5-1.6,2.5-1.3C57.1,44.8,57.7,46,57.4,47z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8564 -0.5163 0.5163 0.8564 -55.2217 75.3256)",
    fill: "#7AA28D",
    cx: 107.8,
    cy: 136.9,
    rx: 30.5,
    ry: 67.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7AA28D",
    d: "M147.5,151c-12.1-34.6-42.5-13.2-42.5-13.2l8.4,50c0,0,26.7,15.6,41.4,21.7c5,2.1,11.3,3.8,18.1,4.7V195 C164.3,186.7,155.1,172.9,147.5,151z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#528E73",
    d: "M130.5,214.9h-9.3l0.9-4.2l3.7-0.7c0,0-9.4-27.9-11.2-33.2c-1.8-5.3,0-14.8,12.2-14.8s13.4,11.3,12.6,14.8 C138.6,180.2,130.5,214.9,130.5,214.9z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "25.7,66.5 23.7,62.3 26.9,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "28.3,65.2 26.2,61.1 29.5,59.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "30.8,64 28.8,59.9 32,58.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.3,62.8 31.3,58.6 34.6,57.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "35.9,61.6 33.9,57.4 37.1,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "38.4,60.3 36.4,56.2 39.7,54.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "41,59.1 39,55 42.2,53.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "43.5,57.9 41.5,53.7 44.7,52.2  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 56.9,
    cy: 44.1,
    r: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M56.5,42.4c0.2,0.8-0.3,1.7-1.2,1.9c-0.6,0.1-1.2-0.1-1.6-0.5c0,0.3,0,0.7,0.1,1c0.4,1.7,2.1,2.7,3.8,2.3 c1.7-0.4,2.7-2.1,2.3-3.8c-0.4-1.7-2.1-2.7-3.8-2.3c-0.2,0.1-0.5,0.2-0.7,0.3C56,41.5,56.4,41.9,56.5,42.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#528E73",
    d: "M55.8,39.2c-2.7,0.7-4.3,3.4-3.7,6.1c0.2,0.7,0.5,1.3,0.9,1.8l7.7-6.4C59.5,39.4,57.6,38.8,55.8,39.2z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 22.1987 149.2247)",
    fontFamily: "'RobotoSlab-Thin'",
    fontSize: 80.612
  }, "100")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#528E73",
    d: "M58.9,136.4c-3.5,0-7-0.6-10.5-1.7l5.7-2.7l-3.2-4.7c11.6,3.9,24.3-1.1,30.1-11.9c4.1-7.6,10.7-3.8,6.8,3.7 C82.1,130.1,70.7,136.4,58.9,136.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100);
export default __webpack_public_path__ + "static/media/100.95572a6e6bd9b1d440cf4c7f8b2f114e.svg";
export { ForwardRef as ReactComponent };